import { render } from "./ProjectNavigationArchive.vue?vue&type=template&id=1122ea72"
import script from "./ProjectNavigationArchive.vue?vue&type=script&lang=js"
export * from "./ProjectNavigationArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__